import SideMenu from "./side-menu";

export { SideMenu };
